module.exports = __webpack_public_path__ + "static/media/teel.8be6be2b.jpg";